export default {
    GENERAL_LOGIN:'GENERAL_LOGIN',//登录后的人物属性
    UM_FILELEVEL_LOADING :'UM_FILELEVEL_LOADING',  // 显示全部文件层级
    UM_FILELEVEL_GETALL  :'UM_FILELEVEL_GETALL',

    UM_FILES_LOADING     :'UM_FILES_LOADING',      // 更新单个层级中的文件
    UM_FILES_GET         :'UM_FILES_GET',

    TS_FILES_LOADING:'TS_FILES_LOADING',
    TS_FILES_GET:'TS_FILES_GET',

    P_ORG:'P_ORG',
    P_ORG_CLEAR: 'P_ORG_CLEAR',
};